<ng-template #shapeTemplate>
    <svg:rect attr.id="{{shape.shapeProperties.name}}" class="draggable" attr.x="{{ shape.originX }}" attr.y="{{ shape.originY }}" attr.width="{{ shape.width }}" attr.height="{{ shape.height }}" [ngStyle]="setStyles()">
        <!-- <title>{{ shape.shapeProperties.name }}</title> -->
    </svg:rect>
</ng-template>